import ApiService from "@/common/api/api.service";

export const FinancialService = {


    list() {
        ApiService.setHeader()
        return ApiService.get('bank')
    },

    get(slug) {
        ApiService.setHeader()
        return ApiService.get('financial', slug)
    },
    getID(id) {
        ApiService.setHeader()
        return ApiService.get(`financial/${id}`)
    },

    getIDFile(id) {
        ApiService.setHeader()
        return ApiService.getFile(`financial/${id}/file`)
    },


    search(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`financials?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },

    searchPayments(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`payments?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },
    
    post(data) {
        ApiService.setHeader()
        return ApiService.post('financial', data)
    },
    createBank(data) {
        ApiService.setHeader()
        return ApiService.post('bank', data)
    },
    setDefaultBank(id) {
        ApiService.setHeader()
        return ApiService.update('bank', id)
    },
    deleteBank(id) {
        ApiService.setHeader()
        return ApiService.delete(`bank/${id}`)
    },

    addMovement(data) {
        ApiService.setHeader()
        return ApiService.post('/financial/account/movement', data)
    },
    deleteMovementAccount(id) {
        ApiService.setHeader()
        return ApiService.delete(`/financial/account/movement/${id}`)
    },
    listMovement() {
        ApiService.setHeader()
        return ApiService.get('/financial/account/movement')
    },
    listMovementBanks() {
        ApiService.setHeader()
        return ApiService.get('/financial/account/movement/banks')
    },
    listReceipt() {
        ApiService.setHeader()
        return ApiService.get('/financial/account/receipt')
    },

    addReceipt(data) {
        ApiService.setHeader()
        return ApiService.post('/financial/account/receipt', data)
    },
    deleteReceiptAccount(id) {
        ApiService.setHeader()
        return ApiService.delete(`/financial/account/receipt/${id}`)
    },
    listAccounts() {
        ApiService.setHeader()
        return ApiService.get('/checkouts/accounts')
    },

}